export const HCO_CUBE_NAME = 'hco';
export const HCO_ALL_LOCATIONS_CUBE_NAME = 'hcos_all_locations';
export const HCP_IN_HCO_CUBE_NAME = 'hcp_in_hco';
export const HCO_HIERARCHY_CUBE_NAME = 'hco_hierarchy';
export const HCO_ACCOUNT_PLAN_CUBE_NAME = 'hco_account_plan';
export const HCP_HCO_CUBE_NAME = 'hcp_hco';
export const INDIVIDUAL_PRODUCT_ATTENDEE_CUBE_NAME = 'interaction_individual_product_attendee';

export const HCP_IN_HCO_DISTINCT_COUNT_MEASURE = `${HCP_IN_HCO_CUBE_NAME}.distinctHCPcount`;

export const BK_SEPARATOR = '^^';

export const NO_MATCH_HCP_BK = '__ces_hco_no_match__';
